/**
* 格式化时间
* @param {any} 字符串或者Date
* @param {String} 需要返回时间格式；如：yyyy-MM-dd HH:mm:ss
* @return {String} 返回格式化后时间
**/
export const format = (time, formatStr = 'yyyy-MM-dd HH:mm:ss') => {
  var t = new Date(time)
  var tf = function (i) {
    return (i < 10 ? '0' : '') + i
  }
  return formatStr.replace(/yyyy|MM|dd|HH|mm|ss|se/g, function (a) {
    let str = ''
    switch (a) {
      case 'yyyy':
        str = tf(t.getFullYear())
        break
      case 'MM':
        str = tf(t.getMonth() + 1)
        break
      case 'mm':
        str = tf(t.getMinutes())
        break
      case 'dd':
        str = tf(t.getDate())
        break
      case 'HH':
        str = tf(t.getHours())
        break
      case 'ss':
        str = tf(t.getSeconds())
        break
      case 'se':
        str = t.getMilliseconds()
        break
    }
    return str
  })
}

export const monthDays = (month) => {
  const now = new Date()
  if (typeof month === 'undefined') month = now.getMonth()
  const start = new Date(now.getFullYear(), month, 1)
  const end = new Date(now.getFullYear(), month + 1, 1)

  return (end - start) / (1000 * 3600 * 24)
}

/**
 * 本月开始时间
 * **/
export const monthStartTime = (offsetMonth = 0, date) => {
  if (!date) date = new Date()
  return new Date(date.getFullYear(), date.getMonth() + offsetMonth, 1, 0, 0, 0)
}

/**
 * 本月结束时间
 * **/
export const monthEndTime = (offsetMonth = 0, date) => {
  if (!date) date = new Date()
  return new Date(date.getFullYear(), date.getMonth() + offsetMonth, monthDays(), 0, 0, 0)
}

/**
 * 本周开始时间(周日为开始时间)
 * **/
export const weekStartTime = (offsetWeek = 0, date) => {
  if (!date) date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + 7 * offsetWeek, 0, 0, 0)
}


/**
 * 本周结束时间
 * **/
export const weekEndTime = (offsetWeek = 0, date) => {
  if (!date) date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + (6 - date.getDay()) + 7 * offsetWeek, 0, 0, 0)
}

/**
 * 本天开始时间
 * **/
export const dayStartTime = (offsetDay = 0, date) => {
  if (!date) date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + offsetDay, 0, 0, 0)
}

/**
 * 本天结束时间
 * **/
export const dayEndTime = (offsetDay = 0, date) => {
  if (!date) date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + offsetDay, 23, 59, 59)
}

/**
* 休眠
* @param {String} time 休眠时间，单位毫秒
**/
export function sleep (time) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, time || 15)
  })
}

/**
 * 防抖，当持续触发事件时，一定时间段内没有再触发事件，事件处理函数才会执行一次
 * @param {function} func 
 * @param {number} wait 
 * @param {boolean} immediate 是否立即执行，还是后执行，默认false
 * @return {function} 
 */
export function debounce (func, wait = 0, immediate) {
  let timer, context, args
  wait = Math.abs(wait)

  let later = function () {
    timer = setTimeout(() => {
      timer = clearTimeout(timer)
      if (!immediate) {
        func.apply(context, args)
        context = args = null
      }
    }, wait)
  }

  return function () {
    if (!timer) {
      later()
      if (immediate) {
        func.apply(this, arguments)
      } else {
        context = this
        args = arguments
      }
    } else {
      timer = clearTimeout(timer)
      later()
    }
  }
}

/**
 * 节流函数，持续执行的函数，在指定时间间隔内执行一次
 * @param {function} func 
 * @param {number} wait 
 * @param {boolean} isLeading 先后执行，默认后执行
 */
export function throttle (func, wait, isLeading) {
  let timer
  wait = Math.abs(wait)

  return function () {
    if (!timer) {
      // 先执行
      if (isLeading) {
        func.apply(this, arguments)
      }
      timer = setTimeout(() => {
        timer = null
        // 后执行
        if (!isLeading) {
          func.apply(this, arguments)
        }
      }, wait)
    }
  }
}
